// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.middleSection {
    background-color: var(--middelColor);
    width: auto;
    height: 100%;
    padding-right: 4em;
}

@media only screen and (max-width: 878px) {
    .middleSection {
        background-color: var(--middelColor);
        width: 100%;
        height: 100%;
        padding-right: 0em;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/dashboard.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,oCAAoC;QACpC,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;AACJ","sourcesContent":[".middleSection {\n    background-color: var(--middelColor);\n    width: auto;\n    height: 100%;\n    padding-right: 4em;\n}\n\n@media only screen and (max-width: 878px) {\n    .middleSection {\n        background-color: var(--middelColor);\n        width: 100%;\n        height: 100%;\n        padding-right: 0em;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
